var _style, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitstoreappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#6776c9}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "rotate(-15 38.459 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    className: "st0",
    d: "M28.6.4l-3.2 11.8c-.4 1.6-2.1 2.6-3.7 2.1-1.6-.4-2.6-2.1-2.1-3.7l3.2-11.8c.4-1.6 2.1-2.6 3.7-2.1C28-2.9 29-1.2 28.6.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0 9.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M19.7-3.2l-1.5 5.6c-.6 2.3.8 4.7 3.1 5.3s4.7-.7 5.3-3l1.6-6.1 12.5 8.2c1.8 1.2 2.8 3.1 2.8 5.3v30.2c0 3.5-2.8 6.3-6.3 6.3h-29c-3.5 0-6.3-2.8-6.3-6.3V12.1c0-2.1 1-4 2.8-5.2l13.8-9.3c.3-.4.8-.6 1.2-.8zm11.6 29.3c0-.7-.2-1.3-.7-1.9l-9.3-9.4c-1-1-2.6-1-3.6 0s-1 2.6 0 3.6l7.6 7.6-7.6 7.6c-1 1-1 2.6 0 3.6s2.6 1 3.6 0l9.3-9.4c.5-.3.7-1 .7-1.7z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitstoreappIcon);
export default __webpack_public_path__ + "static/media/gitstoreapp-icon.4d91afe36b997239a76fd4e83225c8e8.svg";
export { ForwardRef as ReactComponent };